import styled from 'styled-components';

export const TitleAbbrFooter = styled.span`
  font-size: 0.875rem;
  font-weight: 400;
  color: red;
`;
